import { PromoDetail } from "@/core/entities/promotion/PromoDetail";
import { Paragraph } from "@ir/ui";
import { memo } from "react";
import { ProgramInfoCard } from "./ProgramInfoCard";
import { PromoStatusBadge } from "./PromoStatusBadge";
import { PromoDetailInfoRow } from "./PromoDetailInfoRow";
import { getEndDateClassName } from "../utils/promotionDisplay.utils";

interface ProgramLifecycleCardProps {
  promoDetail: PromoDetail;
  dateFormat: string;
}

export const ProgramLifecycleCard = memo(({ promoDetail, dateFormat }: ProgramLifecycleCardProps) => {
  const endDateClassName = getEndDateClassName(promoDetail.isEndDatePast(), promoDetail.isEndDateNear());
  const lifecycleNote = promoDetail.lifecycleNote();

  return (
    <ProgramInfoCard title="Lifecycle">
      <PromoDetailInfoRow
        label="Status"
        value={
          <PromoStatusBadge
            statusName={promoDetail.status.promoStatusName}
            statusKey={promoDetail.status.promoStatusKey}
          />
        }
      />
      <PromoDetailInfoRow
        label="Created"
        value={promoDetail.formatDate(promoDetail.lifecycle.createdAt, dateFormat)}
      />
      {promoDetail.lifecycle.activatedAt && (
        <PromoDetailInfoRow
          label="Activated"
          value={promoDetail.formatDate(promoDetail.lifecycle.activatedAt, dateFormat)}
        />
      )}
      {promoDetail.lifecycle.completedAt && (
        <PromoDetailInfoRow
          label="Completed"
          value={promoDetail.formatDate(promoDetail.lifecycle.completedAt, dateFormat)}
        />
      )}
      {promoDetail.lifecycle.cancelledAt && (
        <PromoDetailInfoRow
          label="Cancelled"
          value={promoDetail.formatDate(promoDetail.lifecycle.cancelledAt, dateFormat)}
        />
      )}
      <PromoDetailInfoRow
        label="Ends"
        value={promoDetail.formatDate(promoDetail.endDate, dateFormat)}
        valueClassName={endDateClassName}
      />
      {lifecycleNote && <Paragraph className="text-grey-500 text-xs pt-3 mb-0 px-4 pb-3">{lifecycleNote}</Paragraph>}
    </ProgramInfoCard>
  );
});

ProgramLifecycleCard.displayName = "ProgramLifecycleCard";
